export const getAutoLayoutWorker = (): Worker =>
  new Worker(new URL("./AutoLayoutWebWorker.ts", import.meta.url));

export const getInitialDataWorker = (): Worker =>
  new Worker(new URL("./InitialDataModificationWebWorker.ts", import.meta.url));

export const getFindNodeWorker = (): Worker =>
  new Worker(new URL("./FindNodeWebWorker.ts", import.meta.url));
